import { Switch } from 'antd'
import Typography from 'antd/es/typography/Typography'
import React from 'react'

const DoctorCallAttemptFilter = ({ doctorCallAttempt, setDoctorCallAttempt }) => {
    return (
        <div className='d-flex justify-content-between align-items-center p-2 border rounded'>
            <Typography.Text>Doctor Call Reattempt</Typography.Text>
            <Switch value={doctorCallAttempt} onChange={(value) => setDoctorCallAttempt(value)} />
        </div>
    )
}

export default DoctorCallAttemptFilter